/* global yaCounter74574325 */
let $document = $(document);
let $window = $(window);

function spentOnPage15sec() {
	clearTimeout($window.data('timeout15Sec'));

	$window.data('timeout15Sec', setTimeout(() => {
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	}, 15000));
}

function clearText(text) {
	return text.toString().trim().replace(/\s+/, ' ');
}


spentOnPage15sec();

jQuery.scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler: (data) => {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
	}
});

// EVENTS
$('.home__logo').on('click', () => {
	ga('send', 'event', 'client click', 'logo header');
});

let $cards = $('.card');
let currentVoce = 1;

let catchCard = (cards) => {
	let viewportTop = $(window).scrollTop();
	let viewportBottom = viewportTop + $(window).height();

	cards.each((i, card) => {
		let $card = $(card);
		let name = $card.find('.card__title').text();
		let num = $card.data('num');
		let cardOffsetTop = $card.offset().top;
		let cardOffsetBottom = cardOffsetTop + $card.height();

		if (viewportTop < cardOffsetBottom && viewportBottom > cardOffsetTop && !$card.data('viewed')) {
			$card.data('viewed', true);
			ga('send', 'event', 'main', 'see block', `${clearText(name)} | ${clearText(num)}`, num);
		}
	});
};

$(window).on('scroll', () => {
	catchCard($cards);
});

$('.card__button').on('click', (e) => {
	let $current = $(e.currentTarget);
	let name = $current.closest('.card').find('.card__title').text();
	let num = $current.closest('.card').data('num');

	ga('send', 'event', 'main', 'vote block', `${clearText(name)} | ${clearText(num)}`, 1);
	ga('send', 'event', 'main', 'vote user counter', currentVoce);

	currentVoce += 1;
});

$('.popup__close').on('click', () => {
	ga('send', 'event', 'main', 'close popup after vote');
});

$('.popup__button').on('click', () => {
	ga('send', 'event', 'main', 'next cliсk popup after vote');
});

$('.card__text a, .card__note a').on('click', (e) => {
	let name = $(e.currentTarget).text();
	let card = $(e.currentTarget).closest('.card').find('.card__title').text();

	ga('send', 'event', 'client', 'text link block', `${clearText(card)} | ${clearText(name)}`);
});

$('.social__button').on('click', (e) => {
	let name = $(e.currentTarget).data('social');

	if (name === undefined) {
		name = $(e.currentTarget).data('social-alt');
	}

	ga('send', 'event', 'share', 'project share footer', name);
});
